import { createSlice , createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { checkErrors } from "../../../jsx/global-functions/checkErrors";

export const updateAdminImageFunc = createAsyncThunk(
    "update admin image function",
    async ({api , data}) => {
        const token = window.localStorage.getItem("token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}` // Include the token in the Authorization header
            }
        }
        try {
            const response = await axios.post(api , data , config);
            return response.data;
        }
        catch (error) {
            checkErrors(error.response , error.message);
        }
        
    }
)

const updateAdminImageSlicer = createSlice({
    name : "update admin image slicer",
    initialState : {
        loading : null,
        data : null,
        error : null
    },
    reducers : {},
    extraReducers : (builder) => {
        builder.addCase(updateAdminImageFunc.pending , (state) => {
            state.loading = true
            state.data = {}
            state.error = false
        });
        builder.addCase(updateAdminImageFunc.rejected , (state) => {
            state.loading = false
            state.data = {}
            state.error = true
        });
        builder.addCase(updateAdminImageFunc.fulfilled , (state , action) => {
            state.loading = false
            state.data = action.payload
            state.error = false
        });
    }
});

export default updateAdminImageSlicer.reducer;